import moment from 'moment';
import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';
import {DATE_DMY} from 'shared/constants/date-format';

import {ISubmitGroupCompanyDto} from '../api/types';
import {EditSubmitGroupCompanyForm} from '../ui/forms/submit-group-company-form';

export const useSubmitGroupCompanyColumns = (
    tableData: ISubmitGroupCompanyDto[] | undefined,
    fetchData: () => Promise<void>,
): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'Код ГК',
                dataIndex: 'groupCode',
                render: (value: string, fields: ISubmitGroupCompanyDto) => (
                    <EditSubmitGroupCompanyForm
                        fields={fields}
                        value={value}
                        fetchData={fetchData}
                    />
                ),
            },
            {
                title: 'Дата, по состоянию на которую представляются сведения',
                dataIndex: 'reportingDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY),
            },
            {title: 'Статус запроса', dataIndex: 'status'},
            {
                title: 'Дата отправки запроса', 
                dataIndex: 'requestDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY)
            },
            {
                title: 'Дата получения ответа', 
                dataIndex: 'responseDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY)
            },
            {title: 'Результат рассмотрения', dataIndex: 'result'},
        ],
        [tableData]
    );
